import React from 'react';
import { Button, Modal, Typography } from '@decub8/ui';

type Props = {
    show: boolean;
    onClose: () => void;
};

const OnboardingSubmitSuccess: React.FC<Props> = ({ show, onClose }) => (
    <Modal noClose show={show} onClose={onClose}>
        <Typography className="mb-8" allBold size="4xl">
            Answers submitted!
        </Typography>
        <Typography className="mb-8" variant="secondary">
            Your answers have been submitted successfully.
            <br />
            You’ll be notified if we need any additional information from you.
            <br />
            Thank you for taking the time to complete this step. <br />
        </Typography>

        <Button className="w-full" onClick={onClose}>
            Got it
        </Button>
    </Modal>
);

export default OnboardingSubmitSuccess;
